import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { isDefined } from "@perxis-auto/shared";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileStatus = memo(function TileStatus2({ isLoading = false, label, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.StatusSkeleton, {});
  }
  if (!isDefined(label)) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarTile.Status, { label, ...props });
});
export {
  TileStatus
};
